exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UiTransitionFade_enter_3Iyy_,.UiTransitionFade_leaveTo_2iv-f{opacity:0}.UiTransitionFade_enterTo_LK-IO,.UiTransitionFade_leave_3tQY-{opacity:1}.UiTransitionFade_enterActive_1sq5s,.UiTransitionFade_leaveActive_1a_pP{-webkit-transition:opacity .3s ease-in-out;transition:opacity .3s ease-in-out}", ""]);

// exports
exports.locals = {
	"enter": "UiTransitionFade_enter_3Iyy_",
	"leaveTo": "UiTransitionFade_leaveTo_2iv-f",
	"enterTo": "UiTransitionFade_enterTo_LK-IO",
	"leave": "UiTransitionFade_leave_3tQY-",
	"enterActive": "UiTransitionFade_enterActive_1sq5s",
	"leaveActive": "UiTransitionFade_leaveActive_1a_pP"
};